import { Medida } from "./medida";
import { Tinte } from "./tinte";

export class DetalleFormula {
    pk?: DetalleFormulaPK;
    tinte: Tinte;
    medida: Medida;
    cantidad: number;
    cantidadPreparacion?: number;
    usercrea?: string;
    fechacrea?: Date;
    usermod?: string;
    fechamod?: Date;
    codigotinte?: string;
}

export interface DetalleFormulaPK {
    idsistema?: number;
    idformula?: string;
    codigotinte: string;
}
